import React from 'react';
import { C, BRAND_GRADIENT } from '../utils/theme.js';
import RadioBot from './RadioBot.jsx';

export default function Sidebar(props) {
  var navItems = props.navItems || [];
  var page = props.page;
  var setPage = props.setPage;

  return (
    <aside style={{
      width: 230,
      flexShrink: 0,
      background: C.s1,
      borderRight: "1px solid " + C.bd,
      display: "flex",
      flexDirection: "column",
      position: "sticky",
      top: 0,
      height: "100vh",
      overflowY: "auto"
    }}>
      {/* Logo */}
      <div
        onClick={function() { setPage(props.qsosLen ? "dashboard" : "home"); }}
        style={{ display: "flex", alignItems: "center", gap: 11, padding: "18px 18px 16px", cursor: "pointer", flexShrink: 0 }}
      >
        <div style={{
          width: 38, height: 38, borderRadius: 11, background: "#10204a",
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0,
          boxShadow: "0 0 22px " + C.a1 + "44"
        }}><RadioBot size={28} /></div>
        <div>
          <div style={{
            fontSize: 18, fontWeight: 800, letterSpacing: 0.3, lineHeight: 1.1,
            background: BRAND_GRADIENT, WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
          }}>HamExpert</div>
          <div style={{ fontSize: 8, color: C.t3, letterSpacing: 2.2, marginTop: 1 }}>QSO LOG ANALYZER</div>
        </div>
      </div>

      {/* Menu */}
      <nav style={{ display: "flex", flexDirection: "column", gap: 3, padding: "6px 10px", flex: 1 }}>
        {navItems.map(function(n) {
          var active = page === n.id;
          return (
            <button
              key={n.id}
              onClick={function() { setPage(n.id); }}
              style={{
                display: "flex", alignItems: "center", gap: 11,
                width: "100%", textAlign: "left",
                background: active ? C.a1 + "18" : "transparent",
                color: active ? C.a1 : C.t2,
                border: "none",
                borderLeft: active ? "3px solid " + C.a1 : "3px solid transparent",
                borderRadius: 8,
                padding: "10px 12px",
                cursor: "pointer",
                fontSize: 13.5,
                fontWeight: active ? 700 : 500,
                fontFamily: "inherit",
                transition: "all .15s",
                whiteSpace: "nowrap"
              }}
              onMouseOver={function(e) { if (!active) { e.currentTarget.style.background = C.s3 + "55"; e.currentTarget.style.color = C.t1; } }}
              onMouseOut={function(e) { if (!active) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = C.t2; } }}
            >
              <span style={{ fontSize: 16, width: 20, textAlign: "center", flexShrink: 0 }}>{n.icon}</span>
              <span>{n.label}</span>
              {n.badge ? (
                <span style={{
                  marginLeft: "auto", flexShrink: 0,
                  minWidth: 18, height: 18, padding: "0 5px",
                  borderRadius: 9, background: C.a5,
                  color: "#0c1133", fontSize: 11, fontWeight: 800,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  lineHeight: 1
                }}>{n.badge}</span>
              ) : null}
            </button>
          );
        })}
      </nav>

      <div style={{ padding: "12px 16px", borderTop: "1px solid " + C.bd, fontSize: 10, color: C.t3, fontFamily: "monospace", flexShrink: 0 }}>
        HamExpert v1.2.2
      </div>
    </aside>
  );
}
